import localforage from 'localforage'

localforage.config({
  name: 'wallbee',
  storeName: 'wallbee',
  driver: [localforage.LOCALSTORAGE, localforage.INDEXEDDB, localforage.WEBSQL],
})

export default localforage
